const banner = {
  "banner_01_title": "Define<span>®</span><br /><em>Classic</em>",
  "banner_01_content": "โทนสีธรรมชาติสําหรับ ความงามของดวงตาตามสไตล์ของคุณ",
  "banner_02_title": "Define<span>®</span><br /><em>Fresh</em>",
  "banner_02_content": "แรงบันดาลใจจากธรรมชาติให้ดวงตามีมิติ",
  "banner_button_01": "Filter ลองเลนส์",
  "banner_button_02": "ส่องเลนส์ Define®",
}

export default banner
